// extracted by mini-css-extract-plugin
module.exports = {"root":"FileUpload_root_FTgfv","input":"FileUpload_input_jQm0t","icon":"FileUpload_icon_8m_J-"};